import React, { useState } from "react";
import clsx from "clsx";
import { useDispatch } from "react-redux";

import { TableRow, TableCell, Box } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { Edit } from "@material-ui/icons";
import MarathonRequests from "services/marathon";
import EditMarathonScoreDialog from "./EditMarathonScoreDialog";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const MarathonScoreTableItem = ({ data }) => {
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [score, setScore] = useState(data.score);
  const [time, setTime] = useState(data.gameTimeInSeconds);
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSaveScore = () => {
    const updatedScore = {
      score: Number(score),
      gameTimeInSeconds: Number(time),
    };
    dispatch(MarathonRequests.updateMarathonScore(data._id, updatedScore));
    setOpenEditDialog(false);
  };

  const handleOpenDialog = () => {
    setScore(data.score);
    setTime(data.gameTimeInSeconds);
    setOpenEditDialog(true);
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {data.owner.personnelCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {data.owner.nationalCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {data.owner.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {data.owner.phone}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {data.score}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot)}
        >
          {data.gameTimeInSeconds}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
        >
          <Box display={"flex"}>
            <Box
              className={classes.createIconContainer}
              onClick={handleOpenDialog}
            >
              <Edit color="primary" />
            </Box>
          </Box>
        </TableCell>
      </TableRow>
      <EditMarathonScoreDialog
        open={openEditDialog}
        handleClose={() => setOpenEditDialog(false)}
        score={score}
        setScore={setScore}
        time={time}
        setTime={setTime}
        onSave={handleSaveScore}
      />
    </React.Fragment>
  );
};

export default MarathonScoreTableItem;
